export var THEME_CHANNEL = '_FELA_THEME_';


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/themeChannel.js
// module id = 472
// module chunks = 1